export default __webpack_public_path__ + "static/mediamuscatgroup-485450345c99b810229554b25323549a.jpg";